/**
 * Detect the old native Kundenportal WebView shells (apps/vetvet).
 * Must NOT use viewport / Handset breakpoints — those also match phone browsers.
 *
 * Keep in sync with PosthogService.clientPlatform().
 */
export type LegacyWebViewPlatform = 'ios' | 'android';

export function isLegacyWebViewShell(userAgent?: string): boolean {
    return getLegacyWebViewPlatform(userAgent) != null;
}

export function getLegacyWebViewPlatform(userAgent?: string): LegacyWebViewPlatform | null {
    const ua =
        userAgent ??
        (typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');
    if (ua.indexOf('vetvetPhitoIosApp') >= 0) {
        return 'ios';
    }
    if (/; wv\)/.test(ua) || ua.indexOf('VetVetKundenportal') >= 0) {
        return 'android';
    }
    return null;
}
